import moment from 'moment';


moment.locale('fr');

export default moment;


// WEBPACK FOOTER //
// ./src/moment/moment.js